var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_37",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.5H0.5V30.5H30.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 23.1288L8.06248 21.0027L6.56329 22.5008L10.1875 26.125L16.5625 19.75L15.0644 18.2519L10.1875 23.1288ZM28.25 30.375H24V28.25H28.25V15.5H24V7C23.9986 5.87326 23.5504 4.79307 22.7536 3.99635C21.9569 3.19962 20.8767 2.75141 19.75 2.75V0.625C21.4401 0.626968 23.0605 1.29925 24.2556 2.49437C25.4507 3.68949 26.123 5.30985 26.125 7V13.375H28.25C28.8134 13.3756 29.3536 13.5996 29.752 13.998C30.1504 14.3964 30.3744 14.9366 30.375 15.5V28.25C30.3744 28.8134 30.1504 29.3536 29.752 29.752C29.3536 30.1504 28.8134 30.3744 28.25 30.375Z",
    fill: "#EBB42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 13.375H17.625V7C17.625 5.30924 16.9534 3.68774 15.7578 2.49219C14.5623 1.29665 12.9408 0.625 11.25 0.625C9.55924 0.625 7.93774 1.29665 6.74219 2.49219C5.54665 3.68774 4.875 5.30924 4.875 7V13.375H2.75C2.18641 13.375 1.64591 13.5989 1.2474 13.9974C0.848883 14.3959 0.625 14.9364 0.625 15.5V28.25C0.625 28.8136 0.848883 29.3541 1.2474 29.7526C1.64591 30.1511 2.18641 30.375 2.75 30.375H19.75C20.3136 30.375 20.8541 30.1511 21.2526 29.7526C21.6511 29.3541 21.875 28.8136 21.875 28.25V15.5C21.875 14.9364 21.6511 14.3959 21.2526 13.9974C20.8541 13.5989 20.3136 13.375 19.75 13.375ZM7 7C7 5.87283 7.44777 4.79183 8.2448 3.9948C9.04183 3.19777 10.1228 2.75 11.25 2.75C12.3772 2.75 13.4582 3.19777 14.2552 3.9948C15.0522 4.79183 15.5 5.87283 15.5 7V13.375H7V7ZM19.75 28.25H2.75V15.5H19.75V28.25Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.3e3d62644f40b72a31a2d27ef82d54ed.svg";
export { ForwardRef as ReactComponent };